import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-activity-completed")
class ActivityCompleted extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <button class='${style.activityCompleted}'>
        <img src='//donna.sistemadulino.com.br/check.png' alt='Confirmar' loading='auto' />
        Concluir atividade
      </button>
    `;
  }

  @on.click("*")
  async [trait.onClick]() {
    await supabase
      .from("activity_completed")
      .insert([
        {
          activity_id: this.dataset.activity,
          user_id: this.dataset.user,
          date: new Date().getTime(),
        },
      ])
      .select();
    location.reload();
    return this;
  }
}

export default ActivityCompleted;
